export const DEFAULT_VALUE = {
  maintainId: "",
  maintainChangeId: "",
  deviceId: "",
  saleCode: "",
  customerCode: "",
  postalAddressName: "",
  postalAddressId: "",
  address: "",
  itemCode: "",
  versionMachine: "",
};
